import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './DesktopSearchBar.module.scss';

type Props = {
  handleSearch: ({ key }: { key: string }) => void;
  setSearchTerm: (value: string) => void;
  submitSearch:()=>void;
  searchTerm: string;
};
const DesktopSearchBar: FC<Props> = ({ handleSearch, setSearchTerm, submitSearch, searchTerm }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.searchBar}>
      <input
        onKeyDown={handleSearch}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder={t('menu.searchPlaceholder')}
        value={searchTerm}
        type="text"
      />
      <span onClick={submitSearch}>
        <i className="fa fa-search" aria-hidden="true"/>
      </span>
    </div>
  );
};

export default DesktopSearchBar;
